module.exports = "<div class=container style=margin-top:5%;height:80%> <div class=jumbotron> <h1>Internet Explorer wordt niet ondersteund</h1> <p>Het ziet eruit dat u gebruik maakt van Internet Explorer. Op het moment ondersteund deze applicatie geen Internet Explorer.</p> <p>Om gebruik te maken van de deze applicatie gebruik Chrome of Firefox.</p> <p><a class=\"btn btn-lg btn-primary\" href=https://www.google.com/chrome/ >Download Chrome</a></p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/main/browser.page.html
// module id = 389
// module chunks = 0